import { DateTime } from 'luxon'
import { intlDateTimeFormatObjects } from '@/utils/dateTimeFormats'

const MESSAGE_NOTIFICATION_TYPES = new Set([
    'event.broadcast',
    'group.broadcast',
    'site_admin.announcement'
])

const formatEventReminderLabel = (payload) => {
    const eventName = payload?.event_name || 'your event'
    const eventDateTime = payload?.date_time
        ? DateTime.fromISO(payload.date_time)
        : null

    if (!eventDateTime?.isValid) {
        return `Reminder: ${eventName} starts soon`
    }

    const formattedStart = eventDateTime.toLocaleString(
        intlDateTimeFormatObjects.SHORT_DAY_MONTH_YEAR_TIME
    )
    return `Reminder: ${eventName} starts ${formattedStart}`
}

export const getNotificationLabel = (notification) => {
    const actor = notification.actor

    if (notification.type === 'notifications.groups.newGroupMember' && notification.payload) {
        const memberName = actor?.display_name || notification.payload.memberName || 'Someone'
        const groupName = notification.payload.groupName || 'your group'
        return `${memberName} joined ${groupName}`
    }

    if (notification.type === 'notifications.groups.newGroupEvent' && notification.payload) {
        return `${notification.payload.groupName} just announced ${notification.payload.eventName}`
    }

    if (notification.type === 'EVENT_REMINDER') {
        return formatEventReminderLabel(notification.payload)
    }

    if (notification.type === 'follow_activity' && notification.payload) {
        const name = notification.payload.name ? `: ${notification.payload.name}` : ''
        return `${actor?.display_name ?? notification.payload.username} ${notification.verb}${name}`
    }

    if (notification.type === 'group.broadcast' && notification.payload) {
        const groupName = notification.payload.group_name || 'Group'
        const subject = notification.payload.subject || 'New message'
        return `${groupName}: ${subject}`
    }

    if (notification.type === 'event.broadcast' && notification.payload) {
        const eventName = notification.payload.event_name || 'Event'
        const subject = notification.payload.subject || 'New message'
        return `${eventName}: ${subject}`
    }

    if (notification.type === 'site_admin.announcement' && notification.payload) {
        return notification.payload.title || 'Site announcement'
    }

    if (notification.type?.startsWith('alert.') && notification.payload) {
        return (
            notification.payload.title ||
            notification.payload.summary ||
            'Alert'
        )
    }

    return actor
        ? `${actor.display_name}${notification.verb ? ` ${notification.verb}` : ''}`
        : notification.type
}

export const getNotificationUrl = (notification) => {
    const url = notification.payload?.url
    if (!url) {
        return url
    }

    if (notification.type === 'EVENT_REMINDER') {
        return url.replace('/event/event/', '/event/')
    }

    return url
}

export const getNotificationTargetUrl = (notification) =>
    notification.payload?.target_url || null

export const getNotificationBody = (notification) => {
    const payload = notification.payload
    if (!payload) return ''
    return (
        payload.message ||
        payload.body ||
        payload.text ||
        payload.title ||
        payload.description ||
        payload.details ||
        payload.content ||
        ''
    )
}

export const isMessageNotification = (notification) =>
    MESSAGE_NOTIFICATION_TYPES.has(notification.type) &&
    Boolean(getNotificationBody(notification))
